import PageLayout from '../../components/page-layout';
import ProductList from './components/ProductList';

export default function ProductManagementPage() {
    return (
        <PageLayout>
            <ProductList />
        </PageLayout>
    );
}
